import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Loadable, ToastMessage } from '../../../../common';
import {
    Portlet, PortletBody,
    PortletHeader, PortletHeaderToolbar
} from "../../../../partials/content/Portlet";

import {
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    Switch,
    TextField,
    Tooltip,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import DeleteIcon from '@mui/icons-material/Delete';
import { BackButton } from "../../../../common/BackButton";
import { ConfigurationClearConfirmationDialog } from "../ClientsConfigurationClearConfirmationDialog";
import { AddClientsDialog } from "../ClientsDialog";
import { errorToastify } from "../../../../util/toast";
import { FHIRProviderType } from "../../../../store/constants/pages";

const useStyles = makeStyles(theme => ({
    deleteButton: {
        color: '#d9534f',
        marginLeft: '20px',
    },
    button: {
        margin: theme.spacing(1),
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '80%',
    },
    textArea: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '80%',
    },
    switch: {
        margin: theme.spacing(1),
    },
    switchAccount: {
        margin: 0,
    },
    switchAccountFormLabel: {

        position: 'absolute',
        bottom: 0
    },
    margin: {
        margin: theme.spacing(1),
    },

    formControl: {
        margin: theme.spacing(1),
        width: '80%',
    },
    updatedSection: {
        display: 'block'
    },
    approveIcon: {
        position: 'absolute',
        bottom: '10px'
    },
    updatedSectionContainer: {
        marginLeft: '8px'
    }

}));

export default function ClientConfigurationPage({
    intl, initialValues, initialValuesAccount, initialValuesFHIR, clientId, configuration, isEdit, client, updateAccountPending, updateFHIRPending,
    isAccountEdit, isFHIREdit, history,
    getClientPending, getClientAccountPending, getClientFHIRPending, createClientPending, createClientAccountPending, createClientFHIRPending, updateClientPending, deleteClientPending, isSuperAdmin,
    actions: {
        getAccountConfiguration,
        getFHIRConfiguration,
        getConfiguration,
        createConfiguration,
        createAccountConfiguration,
        createFHIRConfiguration,
        updateConfiguration,
        updateAccountConfiguration,
        updateFHIRConfiguration,
        deleteConfiguration,
        resetClientConfiguration,
        resetClientAccountConfiguration,
        resetClientFHIRConfiguration,
        getClient,

    } }) {

    const classes = useStyles();

    const [open, setOpen] = useState(false)
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)

    useEffect(() => {
        getConfiguration(clientId, isSuperAdmin);
        getAccountConfiguration(clientId);
        getFHIRConfiguration(clientId);
        return () => {
            resetClientConfiguration();
            resetClientAccountConfiguration();
            resetClientFHIRConfiguration();
        }
    }, [clientId, getConfiguration, resetClientConfiguration, getAccountConfiguration, getFHIRConfiguration]);

    useEffect(() => {
        getClient(clientId);
    }, [getClient, clientId]);

    const handleCallback = () => {
        getConfiguration(clientId, isSuperAdmin)
        history.push('/admin/clients?persist=true');
    }


    const handleDialogOpen = () => { setOpen(true) }
    const handleDialogClose = () => { setOpen(false) }
    const handleConfirmationDialogOpen = () => { setOpenConfirmationDialog(true) }
    const handleConfirmationDialogClose = () => { setOpenConfirmationDialog(false) }

    const handleDeleteConfiguration = () => {
        handleConfirmationDialogClose()
        deleteConfiguration(clientId, handleCallback)
    }

    return (<>
        <Loadable loading={getClientPending || createClientPending || updateClientPending || deleteClientPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={values => {
                    const errors = {};

                    if (values.eapgEnabled) {
                        if (!values.siteName) {
                            errors["siteName"] = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (!/^[a-zA-Z0-9 ]+$/.test(values.siteName)) {
                            errors["siteName"] = "Only letters, digits, and spaces allowed";
                        } else if (values.siteName.length < 5) {
                            errors["siteName"] = "Minimum 5 characters";
                        } else if (values.siteName.length > 100) {
                            errors["siteName"] = "Maximum 100 characters";
                        }
                    }


                    return errors;
                }}
                onSubmit={(values, { }) => {

                    let payload = {
                        prefixExcluded: values.prefixExcluded,
                        postfixExcluded: values.postfixExcluded,
                        fileExtensionsExcluded: values.fileExtensionsExcluded,
                        notifyOnFileNotReceived: values.notifyOnFileNotReceived,
                        notifyAfterDaysFileNotReceived: values.notifyAfterDaysFileNotReceived,
                        customClaimStatusEnabled: values.customClaimStatusEnabled,
                        summaryDashboardEnabled: values.summaryDashboardEnabled,
                        usePlanIdMapping: values.usePlanIdMapping,
                        eapgEnabled: values.eapgEnabled,
                        aiEnabled: values.aiEnabled ? !values.claimAnalysisChatbotEnabled && !values.contractDocumentChatbotEnabled && !values.supplementaryKnowledgeableEnabled && !values.supplementaryPromptEnabled && !values.claimSemanticSearchEnabled ? false : values.aiEnabled : false,
                        claimAnalysisChatbotEnabled: values.aiEnabled ? values.claimAnalysisChatbotEnabled : false,
                        contractDocumentChatbotEnabled: values.aiEnabled ? values.contractDocumentChatbotEnabled : false,
                        supplementaryKnowledgeBaseEnabled: values.aiEnabled ? values.supplementaryKnowledgeableEnabled : false,
                        supplementaryPromptEnabled: values.aiEnabled ? values.supplementaryPromptEnabled : false,
                        claimAnalysisFollowupEnabled: values.aiEnabled && values.claimAnalysisChatbotEnabled ? values.claimAnalysisFollowupEnabled : false,
                        contractFollowupEnabled: values.aiEnabled && values.contractDocumentChatbotEnabled ? values.contractFollowupEnabled : false,
                        claimSemanticSearchEnabled: values.aiEnabled ? values.claimSemanticSearchEnabled : false,
                        customRCMTeamAssignmentEnabled: values?.customRCMTeamAssignmentEnabled,
                        clientId: clientId,
                        ...(values?.eapgEnabled ? { siteName: values?.siteName?.trim() } : {})

                    }
                    if (isEdit) {
                        updateConfiguration(payload, handleCallback)
                    } else {
                        createConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    dirty
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                        <Portlet>
                            <PortletHeader
                                toolbar={
                                    <PortletHeaderToolbar className='w-100'>
                                        <Grid container alignItems="center">
                                            <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                <Typography className="text-dark" variant="h6">{`Configuration - ${client?.name}`}</Typography>
                                                {isEdit &&
                                                    <Tooltip title="Clear Configuration of this client">
                                                        <Button
                                                            size="small"
                                                            onClick={handleConfirmationDialogOpen}
                                                            className={classes.deleteButton}
                                                            startIcon={<DeleteIcon />}>
                                                            Clear
                                                        </Button>
                                                    </Tooltip>
                                                }
                                            </Grid>
                                            <Grid md={6} container className="justify-content-end" >
                                                <BackButton text={dirty ? "Cancel" : "Back"} defaultRoute="/admin/clients?persist=true" />
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    type="submit"
                                                    disabled={createClientPending || updateClientPending || (isEdit && !dirty)}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />
                            <PortletBody>
                                <div className={classes.container}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="Prefix Excluded"
                                                name="prefixExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.prefixExcluded}
                                                helperText='e.g. SLICED_;HEALTH_'
                                                error={Boolean(touched.prefixExcluded && errors.prefixExcluded)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="Postfix Excluded"
                                                name="postfixExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.postfixExcluded}
                                                helperText='e.g. _SLICED;_HEALTH'
                                                error={Boolean(touched.postfixExcluded && errors.postfixExcluded)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                multiline
                                                minRows='1'
                                                maxRows='8'
                                                label="File Extensions Excluded"
                                                name="fileExtensionsExcluded"
                                                className={classes.textArea}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.fileExtensionsExcluded}
                                                helperText='e.g. exe;pdf;word'
                                                error={Boolean(touched.fileExtensionsExcluded && errors.fileExtensionsExcluded)}
                                            />
                                        </div>
                                        <div className="col-md-6" >
                                            <TextField
                                                label="Notify After Days File Not Received"
                                                name="notifyAfterDaysFileNotReceived"
                                                type="number"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.notifyAfterDaysFileNotReceived}
                                                helperText={touched.notifyAfterDaysFileNotReceived && errors.notifyAfterDaysFileNotReceived}
                                                error={Boolean(touched.notifyAfterDaysFileNotReceived && errors.notifyAfterDaysFileNotReceived)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                className={classes.updatedSection}
                                                control={
                                                    <Switch
                                                        name="notifyOnFileNotReceived"
                                                        checked={values.notifyOnFileNotReceived}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}
                                                        value={values.notifyOnFileNotReceived}
                                                    />
                                                }
                                                label="Notify On File Not Received"
                                            />
                                            {isSuperAdmin &&
                                                <FormControlLabel
                                                    className={classes.updatedSection}
                                                    control={
                                                        <Switch
                                                            name="customRCMTeamAssignmentEnabled"
                                                            checked={values.customRCMTeamAssignmentEnabled}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            className={classes.switch}
                                                            value={values.customRCMTeamAssignmentEnabled}
                                                        />
                                                    }
                                                    label="Enable RCM Teams"
                                                />}

                                            {isSuperAdmin &&
                                                <Box sx={{ display: 'flex', columnGap: "30px" }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                name="eapgEnabled"
                                                                checked={values.eapgEnabled}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                className={classes.switch}
                                                                value={values.eapgEnabled}
                                                            />
                                                        }
                                                        label="Enable EAPG"
                                                    />
                                                    {values.eapgEnabled && <TextField

                                                        label="Site Name"
                                                        required
                                                        name="siteName"
                                                        sx={{ "&.MuiFormControl-root": { width: "300px", margin: 0 } }}
                                                        margin="normal"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.siteName}
                                                        helperText={touched.siteName && errors.siteName}
                                                        error={Boolean(touched.siteName && errors.siteName)}
                                                    />}
                                                </Box>
                                            }

                                            {isSuperAdmin &&
                                                // <FormControlLabel
                                                //     className={classes.updatedSection}
                                                //     control={
                                                //         <Switch
                                                //             name="aiEnabled"
                                                //             checked={values.aiEnabled}
                                                //             onChange={handleChange}
                                                //             onBlur={handleBlur}
                                                //             className={classes.switch}
                                                //             value={values.aiEnabled}
                                                //         />
                                                //     }
                                                //     label="Enable AI Features"
                                                // />


                                                <ul className="tree">
                                                    <li style={{ paddingLeft: "12px" }}>
                                                        <summary style={{
                                                            marginLeft: '-12px',
                                                            marginBottom: '-10px'
                                                        }}><FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        name="aiEnabled"
                                                                        color="primary"
                                                                        checked={values.aiEnabled}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.aiEnabled}
                                                                    />
                                                                }
                                                                label="AI Capabilities"
                                                            /></summary>
                                                        {values.aiEnabled && <ul>
                                                            <li>
                                                                <details open>
                                                                    <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                        <div>
                                                                            <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                control={
                                                                                    <Switch
                                                                                        size="small"
                                                                                        name="claimAnalysisChatbotEnabled"
                                                                                        color="primary"
                                                                                        checked={values.claimAnalysisChatbotEnabled}
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.claimAnalysisChatbotEnabled}
                                                                                    />
                                                                                }
                                                                                label="Claim Analysis Chatbot"
                                                                                sx={{ marginRight: "unset" }}
                                                                            />
                                                                        </div>
                                                                    </summary>
                                                                    {/* TODO: Uncomment for future use - Followup Questions Toggle
                                                                    {values.claimAnalysisChatbotEnabled && <ul>
                                                                        <li>
                                                                            <details open>
                                                                                <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                                    <div>
                                                                                        <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                            control={
                                                                                                <Switch
                                                                                                    size="small"
                                                                                                    name="claimAnalysisFollowupEnabled"
                                                                                                    color="primary"
                                                                                                    checked={values.claimAnalysisFollowupEnabled}
                                                                                                    onChange={handleChange}
                                                                                                    onBlur={handleBlur}
                                                                                                    value={values.claimAnalysisFollowupEnabled}
                                                                                                />
                                                                                            }
                                                                                            sx={{ marginRight: "unset" }}
                                                                                            label="Followup Questions"
                                                                                        />
                                                                                    </div>
                                                                                </summary>
                                                                            </details>
                                                                        </li>
                                                                    </ul>}
                                                                    */}
                                                                </details>
                                                            </li>
                                                            {/* <li>
                                                                <details>
                                                                    <summary style={{ marginLeft: "2px" }}>

                                                                    </summary>
                                                                </details>
                                                            </li> */}
                                                            <li>
                                                                <details open>
                                                                    <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                        <div>
                                                                            <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                control={
                                                                                    <Switch
                                                                                        size="small"
                                                                                        name="contractDocumentChatbotEnabled"
                                                                                        color="primary"
                                                                                        checked={values.contractDocumentChatbotEnabled}
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.contractDocumentChatbotEnabled}
                                                                                    />
                                                                                }
                                                                                sx={{ marginRight: "unset" }}
                                                                                label="Contract Document Chatbot"
                                                                            />
                                                                        </div>
                                                                    </summary>
                                                                    {/* TODO: Uncomment for future use - Followup Questions Toggle
                                                                    {values.contractDocumentChatbotEnabled && <ul>
                                                                        <li>
                                                                            <details open>
                                                                                <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                                    <div>
                                                                                        <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                            control={
                                                                                                <Switch
                                                                                                    size="small"
                                                                                                    name="contractFollowupEnabled"
                                                                                                    color="primary"
                                                                                                    checked={values.contractFollowupEnabled}
                                                                                                    onChange={handleChange}
                                                                                                    onBlur={handleBlur}
                                                                                                    value={values.contractFollowupEnabled}
                                                                                                />
                                                                                            }
                                                                                            sx={{ marginRight: "unset" }}
                                                                                            label="Followup Questions"
                                                                                        />
                                                                                    </div>
                                                                                </summary>
                                                                            </details>
                                                                        </li>
                                                                    </ul>}
                                                                    */}
                                                                </details>
                                                            </li>
                                                            <li>
                                                                <details open>

                                                                    <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                        <div>
                                                                            <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                control={
                                                                                    <Switch
                                                                                        size="small"
                                                                                        name="supplementaryKnowledgeableEnabled"
                                                                                        color="primary"
                                                                                        checked={values.supplementaryKnowledgeableEnabled}
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.supplementaryKnowledgeableEnabled}
                                                                                    />
                                                                                }
                                                                                sx={{ marginRight: "unset" }}
                                                                                label="IQ Knowledge Base"
                                                                            />
                                                                        </div>
                                                                    </summary>
                                                                </details>
                                                            </li>
                                                            <li>
                                                                <details open>
                                                                    <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                        <div>
                                                                            <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                control={
                                                                                    <Switch
                                                                                        size="small"
                                                                                        name="claimSemanticSearchEnabled"
                                                                                        color="primary"
                                                                                        checked={values.claimSemanticSearchEnabled}
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.claimSemanticSearchEnabled}
                                                                                    />
                                                                                }
                                                                                sx={{ marginRight: "unset" }}
                                                                                label="Claim Semantic Search"
                                                                            />
                                                                        </div>
                                                                    </summary>
                                                                </details>
                                                            </li>
                                                            <li>
                                                                <details open>
                                                                    <summary style={{ marginLeft: "2px", width: 'max-content' }}>
                                                                        <div>
                                                                            <FormControlLabel style={{ marginTop: "-4px" }}
                                                                                control={
                                                                                    <Switch
                                                                                        size="small"
                                                                                        name="supplementaryPromptEnabled"
                                                                                        color="primary"
                                                                                        checked={values.supplementaryPromptEnabled}
                                                                                        onChange={handleChange}
                                                                                        onBlur={handleBlur}
                                                                                        value={values.supplementaryPromptEnabled}
                                                                                    />
                                                                                }
                                                                                sx={{ marginRight: "unset" }}
                                                                                label="Supplementary Prompts"
                                                                            />
                                                                        </div>
                                                                    </summary>
                                                                </details>
                                                            </li>
                                                        </ul>}
                                                    </li>
                                                </ul>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                sx={{ display: "block" }}

                                                control={
                                                    <Switch
                                                        name="customClaimStatusEnabled"
                                                        checked={values.customClaimStatusEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}
                                                        value={values.customClaimStatusEnabled}
                                                    />
                                                }
                                                label="Enable Custom Claim Statuses"
                                            />
                                            <FormControlLabel
                                                sx={{ display: "block" }}

                                                control={
                                                    <Switch
                                                        name="summaryDashboardEnabled"
                                                        checked={values.summaryDashboardEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}
                                                        value={values.summaryDashboardEnabled}
                                                    />
                                                }
                                                label="Show Summary Dashboard"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name="usePlanIdMapping"
                                                        checked={values.usePlanIdMapping}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}
                                                        value={values.usePlanIdMapping}
                                                    />
                                                }
                                                label='Process Claims Using Payer Mapping'
                                            />
                                        </div>
                                        <div className="col-md-6">
                                        </div>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>
        {/* Account Section  */}
        <Loadable loading={updateAccountPending || createClientAccountPending || getClientAccountPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValuesAccount}
                validate={values => {

                    const errors: any = {};

                    if (!values.accountIdentifierNumbers) {
                        errors.accountIdentifierNumbers = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    return errors;
                }}
                onSubmit={(values, { }) => {

                    let payload = {
                        accountIdentifierNumbers: values?.accountIdentifierNumbers,
                        mergeClaims: values?.mergeClaims,
                        clientId: clientId,
                    }

                    if (isAccountEdit) {
                        updateAccountConfiguration(payload, handleCallback)
                    }
                    else {
                        createAccountConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    dirty
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                        <Portlet>
                            <PortletHeader
                                toolbar={
                                    <PortletHeaderToolbar className='w-100'>
                                        <Grid container alignItems="center">
                                            <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                <Typography className="text-dark" variant="h6">Account</Typography>


                                            </Grid>
                                            <Grid md={6} container className="justify-content-end">
                                                <BackButton text={dirty ? "Cancel" : "Back"} defaultRoute="/admin/clients?persist=true" />
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    type="submit"
                                                    disabled={!dirty}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />
                            <PortletBody>
                                <div className={classes.container}>
                                    <div className="row" style={{ width: '90%' }}>



                                        <div className="col-md-6">
                                            <TextField
                                                type="number"
                                                required
                                                label="Account digit"
                                                name="accountIdentifierNumbers"
                                                className={classes.textField}

                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.accountIdentifierNumbers}
                                                helperText={
                                                    touched.accountIdentifierNumbers && errors.accountIdentifierNumbers
                                                }
                                                error={Boolean(
                                                    touched.accountIdentifierNumbers && errors.accountIdentifierNumbers
                                                )}
                                            />


                                            {initialValuesAccount?.updatedAt &&
                                                <Tooltip title="Validate Claims">
                                                    <IconButton size='small' onClick={handleDialogOpen} className={classes.approveIcon}>
                                                        <CheckCircleOutlineIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            }



                                        </div>

                                        <div className="col-md-6">
                                            <FormControlLabel
                                                className={classes.switchAccountFormLabel}
                                                control={
                                                    <Switch
                                                        name="mergeClaims"
                                                        checked={values.mergeClaims}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switchAccount}
                                                        value={values.mergeClaims}
                                                    />
                                                }
                                                label="Merge claims by account id."
                                            />
                                        </div>



                                    </div>

                                </div>
                                {initialValuesAccount?.updatedAt &&
                                    <div className={classes.updatedSectionContainer}>
                                        <span className={classes.updatedSection}>
                                            <b>Updated At :</b> {initialValuesAccount?.updatedAt}
                                        </span>

                                        <span className={classes.updatedSection}>
                                            <b>Updated by :</b> &nbsp;{initialValuesAccount?.updatedBy}
                                        </span>
                                    </div>
                                }

                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>

        {/* FHIR Section  */}
        <Loadable loading={updateFHIRPending || createClientFHIRPending || getClientFHIRPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValuesFHIR}
                validate={values => {
                    const errors: any = {};

                     if (values.providerType != 0 && values.providerType != 1) {
                         errors.providerType = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.practiceId) {
                         errors.practiceId = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.providerClientSecret) {
                         errors.providerClientSecret = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                     if (!values.providerClientId) {
                         errors.providerClientId = intl.formatMessage({
                             id: "AUTH.VALIDATION.REQUIRED_FIELD"
                         });
                     }

                    return errors;
                }}
                onSubmit={(values, { }) => {
                    let payload = {
                        providerType: values?.providerType,
                        practiceId: values?.practiceId,
                        providerClientSecret: values?.providerClientSecret,
                        providerClientId: values?.providerClientId,
                        isPatientDetailsEnabled: values?.isPatientDetailsEnabled,
                        isClaimNotedEnabled: values?.isClaimNotedEnabled,
                        clientId
                    }

                    if (isFHIREdit) {
                        updateFHIRConfiguration(payload, handleCallback)
                    }
                    else {
                        createFHIRConfiguration(payload, handleCallback)
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    dirty
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" className={classes.container}>
                        <Portlet>
                            <PortletHeader
                                toolbar={
                                    <PortletHeaderToolbar className='w-100'>
                                        <Grid container alignItems="center">
                                            <Grid md={6} spacing={2} container alignItems="center" className="pl-3">
                                                <Typography className="text-dark" variant="h6">FHIR</Typography>


                                            </Grid>
                                            <Grid md={6} container className="justify-content-end">
                                                <BackButton text={dirty ? "Cancel" : "Back"} defaultRoute="/admin/clients?persist=true" />
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className='ml-3'
                                                    type="submit"
                                                    disabled={!dirty}
                                                >
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </PortletHeaderToolbar>
                                }
                            />
                            <PortletBody>
                                <div className={classes.container}>
                                    <div className="row" style={{ width: '90%' }}>
                                        <div className="col-md-6">
                                            <FormControl className={classes.formControl}>
                                                <InputLabel htmlFor="providerType">EHR</InputLabel>
                                                <Select
                                                    required={true}
                                                    name="providerType"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.providerType}
                                                    error={Boolean(touched.providerType && errors.providerType)}
                                                >
                                                    {FHIRProviderType.map((item, index) => (
                                                        <MenuItem
                                                            key={`${item.id}`}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>{touched.providerType && errors.providerType}</FormHelperText>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                label="Client ID"
                                                required
                                                name="providerClientId"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.providerClientId}
                                                helperText='e.g. AthenaHealth API ClientId'
                                                error={Boolean(touched.providerClientId && errors.providerClientId)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextField
                                                label="Client Secret"
                                                required
                                                name="providerClientSecret"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.providerClientSecret}
                                                helperText='e.g. AthenaHealth API ClientSecret'
                                                error={Boolean(touched.providerClientSecret && errors.providerClientSecret)}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <TextField
                                                label="PracticeId"
                                                required
                                                name="practiceId"
                                                className={classes.textField}
                                                margin="normal"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.practiceId}
                                                helperText='e.g. Facility Practice Id'
                                                error={Boolean(touched.practiceId && errors.practiceId)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                sx={{ paddingTop: 3 }}
                                                control={
                                                    <Switch
                                                        name="isPatientDetailsEnabled"
                                                        checked={values.isPatientDetailsEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}                                                        
                                                    />
                                                }
                                                label="Patient Details"
                                            />
                                            
                                        </div>
                                        <div className="col-md-6">
                                            <FormControlLabel
                                                sx={{ paddingTop: 3 }}
                                                control={
                                                    <Switch
                                                        name="isClaimNotedEnabled"
                                                        checked={values.isClaimNotedEnabled}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        className={classes.switch}                                                        
                                                    />
                                                }
                                                label="Claim Notes"
                                            />
                                            
                                        </div>
                                    </div>

                                </div>
                            </PortletBody>
                        </Portlet>
                    </form>
                )}
            </Formik>
        </Loadable>
        <AddClientsDialog open={open} handleClose={handleDialogClose} accountDigit={parseInt(initialValuesAccount?.accountIdentifierNumbers)} clientId={clientId} />
        <ConfigurationClearConfirmationDialog open={openConfirmationDialog} handleClose={handleConfirmationDialogClose} handleSubmit={handleDeleteConfiguration} />
    </>);

}

